function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { LogLevel } from "@logtail/types";
import { makeBatch, makeBurstProtection, makeThrottle, calculateJsonLogSizeBytes } from "@logtail/tools";
import { serializeError } from "serialize-error"; // Set default options for Logtail

var defaultOptions = {
  // Default sync endpoint (protocol + domain)
  endpoint: "https://in.logs.betterstack.com",
  // Maximum number of logs to sync in a single request to Better Stack
  batchSize: 1000,
  // Size of logs (in KiB) to trigger sync to Better Stack (0 to disable)
  batchSizeKiB: 0,
  // Max interval (in milliseconds) before a batch of logs proceeds to syncing
  batchInterval: 1000,
  // Maximum number of times to retry a failed sync request
  retryCount: 3,
  // Minimum number of milliseconds to wait before retrying a failed sync request
  retryBackoff: 100,
  // Maximum number of sync requests to make concurrently
  syncMax: 5,
  // Length of the checked window for logs burst protection in milliseconds (0 to disable)
  burstProtectionMilliseconds: 5000,
  // Maximum number of accepted logs in the specified time window (0 to disable)
  burstProtectionMax: 10000,
  // If true, errors when sending logs will be ignored
  // Has precedence over throwExceptions
  ignoreExceptions: false,
  // If true, errors when sending logs will result in a thrown exception
  throwExceptions: false,
  // Maximum depth (number of attribute levels) of a context object
  contextObjectMaxDepth: 50,
  // Produce a warn log when context object max depth is reached
  contextObjectMaxDepthWarn: true,
  // Produce a warning when circular reference is found in context object
  contextObjectCircularRefWarn: true,
  // If true, all logs will be sent to standard console output functions (console.info, console.warn, ...)
  sendLogsToConsoleOutput: false,
  // If true, all logs will be sent to Better Stack
  sendLogsToBetterStack: true,
  // Function to be used to calculate size of logs in bytes (to evaluate batchSizeLimitKiB)
  calculateLogSizeBytes: calculateJsonLogSizeBytes
};
/**
 * Logtail core class for logging to the Better Stack service
 */

var Logtail = /*#__PURE__*/function () {
  /* CONSTRUCTOR */

  /**
   * Initializes a new Logtail instance
   *
   * @param sourceToken: string - Private source token for logging to Better Stack
   * @param options?: ILogtailOptions - Optionally specify Logtail options
   */
  function Logtail(sourceToken, options) {
    var _this = this;

    _classCallCheck(this, Logtail);

    // Middleware
    this._middleware = []; // Number of logs logged

    this._countLogged = 0; // Number of logs successfully synced with Logtail

    this._countSynced = 0; // Number of logs that failed to be synced to Logtail

    this._countDropped = 0; // First, check we have a valid source token

    if (typeof sourceToken !== "string" || sourceToken === "") {
      throw new Error("Logtail source token missing");
    } // Store the source token, to use for syncing with Better Stack


    this._sourceToken = sourceToken; // Merge default and user options

    this._options = Object.assign(Object.assign({}, defaultOptions), options); // Create a throttler, for sync operations

    var throttle = makeThrottle(this._options.syncMax); // Sync after throttling

    var throttler = throttle(function (logs) {
      return _this._sync(logs);
    }); // Burst protection for logging

    this._logBurstProtection = makeBurstProtection(this._options.burstProtectionMilliseconds, this._options.burstProtectionMax, "Logging");
    this.log = this._logBurstProtection(this.log.bind(this)); // Create a batcher, for aggregating logs by buffer size/interval

    var batcher = makeBatch(this._options.batchSize, this._options.batchInterval, this._options.retryCount, this._options.retryBackoff, this._options.batchSizeKiB * 1024, this._options.calculateLogSizeBytes);
    this._batch = batcher.initPusher(function (logs) {
      return throttler(logs);
    });
    this._flush = batcher.flush;
  }
  /* PUBLIC METHODS */

  /**
   * Flush batched logs to Logtail
   */


  _createClass(Logtail, [{
    key: "flush",
    value: function () {
      var _flush = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this._flush());

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function flush() {
        return _flush.apply(this, arguments);
      }

      return flush;
    }()
    /**
     * Number of entries logged
     *
     * @returns number
     */

  }, {
    key: "logged",
    get: function get() {
      return this._countLogged;
    }
    /**
     * Number of log entries synced with Better Stack
     *
     * @returns number
     */

  }, {
    key: "synced",
    get: function get() {
      return this._countSynced;
    }
    /**
     * Number of entries dropped
     *
     * @returns number
     */

  }, {
    key: "dropped",
    get: function get() {
      return this._countDropped;
    }
    /**
     * Log an entry, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param level (LogLevel) - Level to log at (debug|info|warn|error)
     * @param context: (Context) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */

  }, {
    key: "log",
    value: function () {
      var _log = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(message) {
        var level,
            context,
            wrappedContext,
            _wrappedContext,
            log,
            transformedLog,
            _iterator,
            _step,
            middleware,
            newTransformedLog,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                level = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : LogLevel.Info;
                context = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};

                // Wrap context in an object, if it's not already
                if (_typeof(context) !== "object") {
                  wrappedContext = {
                    extra: context
                  };
                  context = wrappedContext;
                }

                if (context instanceof Error) {
                  _wrappedContext = {
                    error: context
                  };
                  context = _wrappedContext;
                }

                if (!this._options.sendLogsToConsoleOutput) {
                  _context2.next = 18;
                  break;
                }

                _context2.t0 = level;
                _context2.next = _context2.t0 === "debug" ? 8 : _context2.t0 === "info" ? 10 : _context2.t0 === "warn" ? 12 : _context2.t0 === "error" ? 14 : 16;
                break;

              case 8:
                console.debug(message, context);
                return _context2.abrupt("break", 18);

              case 10:
                console.info(message, context);
                return _context2.abrupt("break", 18);

              case 12:
                console.warn(message, context);
                return _context2.abrupt("break", 18);

              case 14:
                console.error(message, context);
                return _context2.abrupt("break", 18);

              case 16:
                console.log("[".concat(level.toUpperCase(), "]"), message, context);
                return _context2.abrupt("break", 18);

              case 18:
                if (!(typeof this._sync !== "function")) {
                  _context2.next = 20;
                  break;
                }

                throw new Error("No Logtail logger sync function provided");

              case 20:
                // Increment log count
                this._countLogged++; // Start building the log message

                log = Object.assign(Object.assign({
                  // Implicit date timestamp
                  dt: new Date(),
                  // Explicit level
                  level: level
                }, context), message instanceof Error ? serializeError(message) : {
                  message: message
                });
                transformedLog = log;
                _iterator = _createForOfIteratorHelper(this._middleware);
                _context2.prev = 24;

                _iterator.s();

              case 26:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 36;
                  break;
                }

                middleware = _step.value;
                _context2.next = 30;
                return middleware(transformedLog);

              case 30:
                newTransformedLog = _context2.sent;

                if (!(newTransformedLog == null)) {
                  _context2.next = 33;
                  break;
                }

                return _context2.abrupt("return", transformedLog);

              case 33:
                transformedLog = newTransformedLog;

              case 34:
                _context2.next = 26;
                break;

              case 36:
                _context2.next = 41;
                break;

              case 38:
                _context2.prev = 38;
                _context2.t1 = _context2["catch"](24);

                _iterator.e(_context2.t1);

              case 41:
                _context2.prev = 41;

                _iterator.f();

                return _context2.finish(41);

              case 44:
                // Manually serialize the log data
                transformedLog = this.serialize(transformedLog, this._options.contextObjectMaxDepth);

                if (this._options.sendLogsToBetterStack) {
                  _context2.next = 47;
                  break;
                }

                return _context2.abrupt("return", transformedLog);

              case 47:
                _context2.prev = 47;
                _context2.next = 50;
                return this._batch(transformedLog);

              case 50:
                // Increment sync count
                this._countSynced++;
                _context2.next = 62;
                break;

              case 53:
                _context2.prev = 53;
                _context2.t2 = _context2["catch"](47);
                // Increment dropped count
                this._countDropped++; // Catch any errors - re-throw if `ignoreExceptions` == false

                if (this._options.ignoreExceptions) {
                  _context2.next = 62;
                  break;
                }

                if (!this._options.throwExceptions) {
                  _context2.next = 61;
                  break;
                }

                throw _context2.t2;

              case 61:
                // Output to console
                console.error(_context2.t2);

              case 62:
                return _context2.abrupt("return", transformedLog);

              case 63:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[24, 38, 41, 44], [47, 53]]);
      }));

      function log(_x) {
        return _log.apply(this, arguments);
      }

      return log;
    }()
  }, {
    key: "serialize",
    value: function serialize(value, maxDepth) {
      var _this2 = this;

      var visitedObjects = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new WeakSet();

      if (value === null || typeof value === "boolean" || typeof value === "number" || typeof value === "string") {
        return value;
      } else if (value instanceof Date) {
        // Date instances can be invalid & toISOString() will fail
        if (isNaN(value.getTime())) {
          return value.toString();
        }

        return value.toISOString();
      } else if (value instanceof Error) {
        return serializeError(value);
      } else if ((_typeof(value) === "object" || Array.isArray(value)) && (maxDepth < 1 || visitedObjects.has(value))) {
        if (visitedObjects.has(value)) {
          if (this._options.contextObjectCircularRefWarn) {
            console.warn("[Logtail] Found a circular reference when serializing logs. Please do not use circular references in your logs.");
          }

          return "<omitted circular reference>";
        }

        if (this._options.contextObjectMaxDepthWarn) {
          console.warn("[Logtail] Max depth of ".concat(this._options.contextObjectMaxDepth, " reached when serializing logs. Please do not use excessive object depth in your logs."));
        }

        return "<omitted context beyond configured max depth: ".concat(this._options.contextObjectMaxDepth, ">");
      } else if (Array.isArray(value)) {
        visitedObjects.add(value);
        var serializedArray = value.map(function (item) {
          return _this2.serialize(item, maxDepth - 1, visitedObjects);
        });
        visitedObjects.delete(value);
        return serializedArray;
      } else if (_typeof(value) === "object") {
        var serializedObject = {};
        visitedObjects.add(value);
        Object.entries(value).forEach(function (item) {
          var key = item[0];
          var value = item[1];

          var serializedValue = _this2.serialize(value, maxDepth - 1, visitedObjects);

          if (serializedValue !== undefined) {
            serializedObject[key] = serializedValue;
          }
        });
        visitedObjects.delete(value);
        return serializedObject;
      } else if (typeof value === "undefined") {
        return undefined;
      } else {
        return "<omitted unserializable ".concat(_typeof(value), ">");
      }
    }
    /**
     *
     * Debug level log, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */

  }, {
    key: "debug",
    value: function () {
      var _debug = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(message) {
        var context,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                context = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
                return _context3.abrupt("return", this.log(message, LogLevel.Debug, context));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function debug(_x2) {
        return _debug.apply(this, arguments);
      }

      return debug;
    }()
    /**
     *
     * Info level log, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */

  }, {
    key: "info",
    value: function () {
      var _info = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(message) {
        var context,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                context = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
                return _context4.abrupt("return", this.log(message, LogLevel.Info, context));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function info(_x3) {
        return _info.apply(this, arguments);
      }

      return info;
    }()
    /**
     *
     * Warning level log, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */

  }, {
    key: "warn",
    value: function () {
      var _warn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(message) {
        var context,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                context = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
                return _context5.abrupt("return", this.log(message, LogLevel.Warn, context));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function warn(_x4) {
        return _warn.apply(this, arguments);
      }

      return warn;
    }()
    /**
     *
     * Warning level log, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */

  }, {
    key: "error",
    value: function () {
      var _error = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(message) {
        var context,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                context = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
                return _context6.abrupt("return", this.log(message, LogLevel.Error, context));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function error(_x5) {
        return _error.apply(this, arguments);
      }

      return error;
    }()
    /**
     * Sets the sync method - i.e. the final step in the pipeline to get logs
     * over to Better Stack
     *
     * @param fn - Pipeline function to use as sync method
     */

  }, {
    key: "setSync",
    value: function setSync(fn) {
      this._sync = fn;
    }
    /**
     * Add a middleware function to the logging pipeline
     *
     * @param fn - Function to add to the log pipeline
     * @returns void
     */

  }, {
    key: "use",
    value: function use(fn) {
      this._middleware.push(fn);
    }
    /**
     * Remove a function from the pipeline
     *
     * @param fn - Pipeline function
     * @returns void
     */

  }, {
    key: "remove",
    value: function remove(fn) {
      this._middleware = this._middleware.filter(function (p) {
        return p !== fn;
      });
    }
  }]);

  return Logtail;
}();

var _default = /*#__PURE__*/function (_Logtail) {
  _inherits(_default, _Logtail);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "log",
    value: function () {
      var _log2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(message) {
        var level,
            context,
            _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                level = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : LogLevel.Info;
                context = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : {};
                return _context7.abrupt("return", _get(_getPrototypeOf(_default.prototype), "log", this).call(this, message, level, context));

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function log(_x6) {
        return _log2.apply(this, arguments);
      }

      return log;
    }()
  }]);

  return _default;
}(Logtail);

export { _default as default };